import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

export const dashboardService = {

    // ------------------------------------------------
    // DASHBOARD
    // ------------------------------------------------

    getDashboard(days = 30) {
        return axios.get(
            API_URL +
            "Dashboard/GetDashboard",
            {
                params: {
                    days
                }
            }
        );
    },

};